export default function SavePreparationItemConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSavePreparationItemDialog = _handleSavePreparationItemDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    loaderService.showViewLoader = true;
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.savePreparationItemConfirmDialog);
  }

  function _handleSavePreparationItemDialog() {
    return amSharedModelService.savePreparationItem(vm.preparationItem)
      .then(() => {
        alerts.success('The Preparation Item has been saved successfully.');
        if (vm.preparationItem.preparationItemId > 0) {
          $rootScope.$broadcast('refreshAMPreparationItem',
            { preparationItemId: vm.preparationItem.preparationItemId });
        } else {
          $rootScope.$broadcast('refreshAMPreparationItems',
            { preparationItemCategoryId: vm.preparationItem.preparationItemCategoryId });
        }
        ssDialogService.hide(ssDialogService.dialogs.auditTrail.savePreparationItemConfirmDialog);
      })
      .catch(() => {
        alerts.error('Error occurred while saving the Preparation Item.');
      });
  }
}

SavePreparationItemConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amSharedModelService',
  'loaderService',
  'ssDialogService'
];
